import { render, staticRenderFns } from "./ModalAddGroup.vue?vue&type=template&id=15d3bcaa&"
import script from "./ModalAddGroup.vue?vue&type=script&lang=ts&"
export * from "./ModalAddGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports